export const getDeviceId = () => {
  let deviceId = localStorage.getItem("device_id");
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem("device_id", deviceId);
  }
  return deviceId;
};

export const getDeviceType = () => {
  if (window.innerWidth <= 768) return "mobile";
  if (window.innerWidth <= 1024) return "tablet";
  return "desktop";
};

export const getBrowserName = () => {
  return navigator.userAgent;
};

export const getSessionId = () => {
  let sessionId = sessionStorage.getItem("session_id");
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem("session_id", sessionId);
  }
  return sessionId;
};

export const getLocalItem = (localKey: string) => {
  return localStorage.getItem(localKey);
};

export const getRecentSearchLocations = (key: string) => {
  const flightDetails = JSON.parse(
    localStorage.getItem("flightDetails") || "{}"
  );
  if (!flightDetails[key]) {
    flightDetails[key] = [];
  }
  return flightDetails[key];
};

export const getCurrentFlightSearchFromLocalStorage = (key: string) => {
  const flightDetails = JSON.parse(
    localStorage.getItem("flightDetails") || "{}"
  );
  if (!flightDetails["lastFlightSearch"]) {
    flightDetails["lastFlightSearch"] = {};
  }
  const keys = key.split(".");
  let result = flightDetails["lastFlightSearch"];
  for (let k of keys) {
    result = result ? result[k] : null;
  }
  return result || "";
};

export const updatedRecentSearches = (key: string, newSearch: any) => {
  const recentSearches = getRecentSearchLocations(key);
  const duplicateIndex = recentSearches.findIndex(
    (search: any) => search.flightplace_code === newSearch.flightplace_code
  );
  if (duplicateIndex === -1) {
    recentSearches.unshift(newSearch);
    if (recentSearches.length > 5) recentSearches.pop();
  }
  return recentSearches;
};

export const filterOutRecentSearches = (
  fromOptions: any[],
  recentFromOptions: any[]
) => {
  return fromOptions.filter(
    (fromOption) =>
      !recentFromOptions.some(
        (recentOption) =>
          recentOption.flightplace_code === fromOption.flightplace_code
      )
  );
}; 